'use strict';

var chunk3CUP7X6U_js = require('./chunk-3CUP7X6U.js');
var i = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var i__default = /*#__PURE__*/_interopDefault(i);

var f=p=>{let{size:a,onClick:l,fill:o="#0F0F10"}=p;return i__default.default.createElement(chunk3CUP7X6U_js.a,{fill:o,onClick:l,size:a,viewBox:"0 0 26 26"},i__default.default.createElement("path",{d:"M13 0a13 13 0 1013 13A13.013 13.013 0 0013 0zm0 24a11 11 0 1111-11 11.012 11.012 0 01-11 11zm2-5a1 1 0 01-1 1 2 2 0 01-2-2v-5a1 1 0 010-2 2 2 0 012 2v5a1 1 0 011 1zM11 7.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",fill:o}))};

exports.a = f;
